var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"depressed":"","color":"success","disabled":_vm.isDisabled,"loading":_vm.isLoading},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }